import React from 'react';
import {gql} from '@apollo/client';
import isEqual from 'lodash/isEqual';

const extractFullStoryData = props => {
  const {me} = props;
  if (!me || !me.catererAccount) {
    return {};
  }
  const {email, name, trackingId} = me.catererAccount;

  return {email, name, trackingId};
};

function onPropsChange(props, prevProps = {}) {
  if (typeof window === 'undefined' || !window.FS) {
    return;
  }
  const newData = extractFullStoryData(props);
  const oldData = extractFullStoryData(prevProps);

  if (newData.trackingId && !isEqual(newData, oldData)) {
    const {email, name, trackingId} = newData;
    window.FS.identify(trackingId, {
      displayName: name,
      email,
    });
  }
}

export class FullStory extends React.Component {
  componentDidMount = () => {
    onPropsChange(this.props);
  };

  componentDidUpdate = prevProps => {
    onPropsChange(this.props, prevProps);
  };

  render() {
    return null;
  }
}

export const fullStoryFragment = gql`
  fragment FullStory on Identity {
    id
    catererAccount {
      id
      trackingId
      email
      name
    }
  }
`;

export default FullStory;
